export default __webpack_public_path__ + "static/FirmDashboard-c71535f3f84d94aa00888ef78c898bcd.png";